import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import age18Webp from '@/assets/landing-activity-female/age-18.webp'
import age30Webp from '@/assets/landing-activity-female/age-30.webp'
import age40Webp from '@/assets/landing-activity-female/age-40.webp'
import age50Webp from '@/assets/landing-activity-female/age-50.webp'

const schema: LandingScreenSchema = {
	config: {
		dynamicLandingType: 'age_selection',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: ({ $t, ctx }): LandingComponentsConfig['LandingTitle'] => ({
			title: ctx.dynamicLandingData?.title ?? $t('female_activity.pages.landing.step_1.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t, ctx }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title:
				ctx.dynamicLandingData?.subtitle ??
				$t('female_activity.pages.landing.step_1.subtitle', {
					age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
				}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: $t('female_activity.pages.landing.step_1.options.18_29'),
					img: age18Webp,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: $t('female_activity.pages.landing.step_1.options.30_39'),
					img: age30Webp,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_activity.pages.landing.step_1.options.40_49'),
					img: age40Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_activity.pages.landing.step_1.options.50'),
					img: age50Webp,
				},
			],
		}),
	},
}

export default schema
